// extracted by mini-css-extract-plugin
export var content = "index-module--content--ad424";
export var loading = "index-module--loading--e29c5";